import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "flex flex-row" }
const _hoisted_2 = { class: "pt-6 px-2 border-r-2 border-grey" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" Add new user ")
const _hoisted_4 = {
  key: 0,
  class: "bg-blue-200 rounded p-1"
}
const _hoisted_5 = { class: "font-serious" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" Selected user: ")
const _hoisted_7 = { class: "font-playful" }
const _hoisted_8 = { class: "font-serious" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Projects: ")
const _hoisted_10 = { class: "font-playful" }
const _hoisted_11 = { class: "font-serious" }
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" Groups: ")
const _hoisted_13 = { class: "font-playful" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "py-2 text-sm" }, [
  /*#__PURE__*/_createElementVNode("p", null, "Recent activity"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-red-500 mt-1 ml-1" }, "Red > 24h"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-orange-500 ml-1" }, "Orange < 24h"),
  /*#__PURE__*/_createElementVNode("p", { class: "text-green-500 ml-1" }, "Green < 1h")
], -1 /* HOISTED */)
const _hoisted_15 = { class: "flex flex-col pt-2 text-left" }
const _hoisted_16 = ["id", "onClick"]
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }
const _hoisted_19 = { class: "flex-col w-full" }
const _hoisted_20 = { class: "flex flex-row flex-grow py-4 text-left px-2 overflow-y-auto justify-between" }
const _hoisted_21 = { class: "mb-2 font-serious" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("h1", { class: "mb-2 font-serious font-bold" }, "User Details", -1 /* HOISTED */)
const _hoisted_23 = { class: "flex flex-row items-center" }
const _hoisted_24 = /*#__PURE__*/_createTextVNode(" Last login: ")
const _hoisted_25 = { class: "font-playful" }
const _hoisted_26 = {
  key: 0,
  class: "flex flex-col mb-2"
}
const _hoisted_27 = { class: "flex flex-col flex-grow py-4 text-left px-2 overflow-y-auto" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_29 = { class: "flex flex-col" }
const _hoisted_30 = /*#__PURE__*/_createStaticVNode("<h1 class=\"font-serious mb-2 font-bold\">Projects</h1><div class=\"flex flex-row w-full items-center\"><p class=\"w-8 ml-6 font-serious\">Active</p><div class=\"flex flex-row w-full justify-around font-serious\"><p>Name</p><p>Intervention</p><p>TSD Group</p></div><p class=\"mr-6\">Controls</p></div>", 2)
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Remove")
const _hoisted_33 = {
  key: 0,
  class: "flex flex-row mb-2 justify-end"
}
const _hoisted_34 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_35 = { class: "flex flex-col" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("h1", { class: "font-serious mb-2 font-bold" }, "Locations / Kindergartens", -1 /* HOISTED */)
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row w-full items-center" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "flex flex-row w-full justify-around" }, [
    /*#__PURE__*/_createElementVNode("p", null, "Name"),
    /*#__PURE__*/_createElementVNode("p", null, "location")
  ]),
  /*#__PURE__*/_createElementVNode("p", { class: "mr-6" }, "Controls")
], -1 /* HOISTED */)
const _hoisted_38 = /*#__PURE__*/_createTextVNode("Remove")
const _hoisted_39 = { class: "flex flex-row justify-end mb-2" }
const _hoisted_40 = /*#__PURE__*/_createElementVNode("p", { class: "p-2 text-xs" }, "Maximum of 1 group allowed at this time", -1 /* HOISTED */)
const _hoisted_41 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("h1", { class: "font-serious font-bold" }, "Players owned by this User, or a User in the same Location / Kindergarten", -1 /* HOISTED */)
const _hoisted_43 = /*#__PURE__*/_createTextVNode("New Player")
const _hoisted_44 = {
  key: 1,
  class: "text-red-600"
}
const _hoisted_45 = { class: "flex flex-row flex-wrap" }
const _hoisted_46 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("Done editing")
const _hoisted_48 = /*#__PURE__*/_createElementVNode("hr", null, null, -1 /* HOISTED */)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("h1", { class: "font-serious font-bold" }, "Games owned by this User, or a User in the same Location / Kindergarten", -1 /* HOISTED */)
const _hoisted_50 = /*#__PURE__*/_createTextVNode("New Game")
const _hoisted_51 = { class: "flex flex-row flex-wrap" }
const _hoisted_52 = /*#__PURE__*/_createTextVNode("Edit")
const _hoisted_53 = /*#__PURE__*/_createTextVNode("Close")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_AnswerInput = _resolveComponent("AnswerInput")!
  const _component_SelectionBox = _resolveComponent("SelectionBox")!
  const _component_MonitorProjectItem = _resolveComponent("MonitorProjectItem")!
  const _component_MonitorGroupItem = _resolveComponent("MonitorGroupItem")!
  const _component_MonitorPlayerItem = _resolveComponent("MonitorPlayerItem")!
  const _component_MonitorGameItem = _resolveComponent("MonitorGameItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Button, {
        id: "button-add",
        class: "mb-8 focus:outline-none bg-blue-button text-white justify-self-end",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.addUser()))
      }, {
        default: _withCtx(() => [
          _hoisted_3
        ]),
        _: 1 /* STABLE */
      }),
      (_ctx.theUser)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("p", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("strong", _hoisted_7, _toDisplayString(_ctx.theUser.profile.username), 1 /* TEXT */)
            ]),
            _createElementVNode("p", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("strong", _hoisted_10, _toDisplayString(_ctx.theUser.projects.length), 1 /* TEXT */)
            ]),
            _createElementVNode("p", _hoisted_11, [
              _hoisted_12,
              _createElementVNode("strong", _hoisted_13, _toDisplayString(_ctx.theUser.groups.length), 1 /* TEXT */)
            ])
          ]))
        : _createCommentVNode("v-if", true),
      _hoisted_14,
      _createElementVNode("div", _hoisted_15, [
        _createElementVNode("p", {
          class: "cursor-pointer font-serious border rounded-2xl bg-gray-400 p-0.5 text-center",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.selectMyUser()))
        }, "velg min egen bruker"),
        _createElementVNode("p", {
          class: "cursor-pointer font-serious border rounded-2xl bg-gray-400 p-0.5 text-center mb-2",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.refreshUserList()))
        }, " forfriske brukerliste "),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.allUsers, (u, i) => {
          return (_openBlock(), _createElementBlock("p", {
            id: `p-selectuser-${u.profile.username}`,
            key: i,
            class: "cursor-pointer",
            onClick: ($event: any) => (_ctx.selectAUser(u))
          }, [
            (_ctx.theUser && u._id === _ctx.theUser._id)
              ? (_openBlock(), _createElementBlock("span", _hoisted_17, "✔︎ "))
              : (_openBlock(), _createElementBlock("span", _hoisted_18)),
            _createElementVNode("span", {
              class: _normalizeClass(["text-xs font-bold", [{ 'text-red-500': u.lastActive >= 86400, 'text-orange-500': u.lastActive < 86400, 'text-green-500': u.lastActive < 3600 }]])
            }, _toDisplayString(u.profile.username), 3 /* TEXT, CLASS */)
          ], 8 /* PROPS */, _hoisted_16))
        }), 128 /* KEYED_FRAGMENT */))
      ])
    ]),
    _createElementVNode("div", _hoisted_19, [
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _hoisted_22,
          (_ctx.hasAdminRole)
            ? (_openBlock(), _createBlock(_component_AnswerInput, {
                key: 0,
                modelValue: _ctx.theUser.profile.username,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.theUser.profile.username) = $event)),
                valid: _ctx.validators.username,
                "onUpdate:valid": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.validators.username) = $event)),
                mode: "text",
                label: "Brukernavn",
                border: false,
                placeholder: "91234567",
                underline: false,
                class: "p-1 m-1",
                onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.saveUser()))
              }, null, 8 /* PROPS */, ["modelValue", "valid"]))
            : _createCommentVNode("v-if", true),
          (_ctx.hasAdminRole)
            ? (_openBlock(), _createBlock(_component_AnswerInput, {
                key: 1,
                modelValue: _ctx.theUser.profile.email,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.theUser.profile.email) = $event)),
                valid: _ctx.validators.email,
                "onUpdate:valid": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.validators.email) = $event)),
                mode: "email",
                label: "e-post",
                border: false,
                placeholder: "91234567",
                underline: false,
                class: "p-1 m-1",
                onChange: _cache[8] || (_cache[8] = ($event: any) => (_ctx.saveUser()))
              }, null, 8 /* PROPS */, ["modelValue", "valid"]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("div", _hoisted_23, [
            (_ctx.hasAdminRole)
              ? (_openBlock(), _createBlock(_component_AnswerInput, {
                  key: 0,
                  modelValue: _ctx.theUser.profile.mobil,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.theUser.profile.mobil) = $event)),
                  valid: _ctx.validators.mobil,
                  "onUpdate:valid": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.validators.mobil) = $event)),
                  mode: "tel",
                  label: "Mobilnummer",
                  border: false,
                  placeholder: "91234567",
                  underline: false,
                  class: "p-1 m-1",
                  onChange: _cache[11] || (_cache[11] = ($event: any) => (_ctx.saveUser()))
                }, null, 8 /* PROPS */, ["modelValue", "valid"]))
              : _createCommentVNode("v-if", true)
          ]),
          (_ctx.hasAdminRole)
            ? (_openBlock(), _createBlock(_component_SelectionBox, {
                key: 2,
                id: "select-role",
                modelValue: _ctx.currentUserRole,
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.currentUserRole) = $event)),
                label: 'Role..',
                options: _ctx.roleOptionList,
                "reset-on-choose": false,
                onChange: _ctx.updateRole
              }, null, 8 /* PROPS */, ["modelValue", "label", "options", "onChange"]))
            : _createCommentVNode("v-if", true),
          _createElementVNode("p", null, [
            _hoisted_24,
            _createElementVNode("strong", _hoisted_25, _toDisplayString(_ctx.lastLogin), 1 /* TEXT */)
          ])
        ]),
        (_ctx.hasAdminRole)
          ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
              _createVNode(_component_AnswerInput, {
                booleanValue: _ctx.delaysDisabled,
                "onUpdate:booleanValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.delaysDisabled) = $event)),
                class: "m-2",
                mode: "binaryChoice",
                border: false,
                label: "Disable delays (not stored!)",
                description: "Remove deliberate time delays. This is only for testing.",
                onChange: _ctx.disableDelays
              }, null, 8 /* PROPS */, ["booleanValue", "onChange"]),
              _createVNode(_component_AnswerInput, {
                booleanValue: _ctx.theUser.status.canEditPlayers,
                "onUpdate:booleanValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.theUser.status.canEditPlayers) = $event)),
                class: "m-2",
                mode: "binaryChoice",
                border: false,
                description: "This user can: create new Players and change the avatar's name",
                label: "Can edit Players",
                onChange: _cache[15] || (_cache[15] = ($event: any) => (_ctx.saveUser()))
              }, null, 8 /* PROPS */, ["booleanValue"]),
              _createVNode(_component_AnswerInput, {
                booleanValue: _ctx.theUser.status.canEditGames,
                "onUpdate:booleanValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.theUser.status.canEditGames) = $event)),
                class: "m-2",
                mode: "binaryChoice",
                border: false,
                label: "Can edit Games",
                description: "This user can: change a Game's name and shared groups, add / remove Players from Games",
                onChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.saveUser()))
              }, null, 8 /* PROPS */, ["booleanValue"]),
              _createVNode(_component_AnswerInput, {
                modelValue: _ctx.theUser.profile.language,
                "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.theUser.profile.language) = $event)),
                class: "m-2",
                mode: "singleChoice",
                description: "Choose 'system' to allow the user's device to decide",
                border: false,
                options: _ctx.languageList,
                label: "Language",
                onChange: _cache[19] || (_cache[19] = ($event: any) => (_ctx.saveUser()))
              }, null, 8 /* PROPS */, ["modelValue", "options"])
            ]))
          : _createCommentVNode("v-if", true)
      ]),
      _createElementVNode("div", _hoisted_27, [
        _hoisted_28,
        _createCommentVNode(" Project Selection "),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userProjects, (p, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "flex flex-row"
            }, [
              _createVNode(_component_MonitorProjectItem, {
                edit: false,
                project: p,
                selected: p.selected,
                class: "my-2 w-full",
                onSelected: ($event: any) => (_ctx.selectProject(p))
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    id: `button-remove-project-${p._id}`,
                    class: "my-1 mr-2",
                    childclass: 'w-32',
                    backgroundcolour: 'bg-white',
                    onVclick: ($event: any) => (_ctx.removeProject(i))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_32
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "onVclick"])
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["project", "selected", "onSelected"])
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          (_ctx.hasAdminRole)
            ? (_openBlock(), _createElementBlock("div", _hoisted_33, [
                _createVNode(_component_SelectionBox, {
                  id: "select-project",
                  modelValue: _ctx.projectSelected,
                  "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.projectSelected) = $event)),
                  label: 'Add a Project..',
                  options: _ctx.projectOptionList,
                  "reset-on-choose": true,
                  onChange: _ctx.addProject
                }, null, 8 /* PROPS */, ["modelValue", "label", "options", "onChange"])
              ]))
            : _createCommentVNode("v-if", true)
        ]),
        _hoisted_34,
        _createCommentVNode(" Group Selection "),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _hoisted_37,
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedGroups, (g, i) => {
            return (_openBlock(), _createElementBlock("div", {
              key: i,
              class: "flex flex-row"
            }, [
              _createVNode(_component_MonitorGroupItem, {
                edit: false,
                group: g,
                class: "my-2 w-full"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_Button, {
                    id: `button-remove-group-${g._id}`,
                    class: "my-1 mr-2",
                    childclass: 'w-32',
                    backgroundcolour: 'bg-white',
                    onVclick: ($event: any) => (_ctx.removeGroup(i))
                  }, {
                    default: _withCtx(() => [
                      _hoisted_38
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "onVclick"])
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["group"])
            ]))
          }), 128 /* KEYED_FRAGMENT */)),
          _withDirectives(_createElementVNode("div", _hoisted_39, [
            _createElementVNode("div", null, [
              _createVNode(_component_SelectionBox, {
                id: "select-group",
                modelValue: _ctx.groupSelected,
                "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.groupSelected) = $event)),
                label: 'Add a Group..',
                options: _ctx.groupOptionList,
                "reset-on-choose": true,
                onChange: _ctx.addGroupToUser
              }, null, 8 /* PROPS */, ["modelValue", "label", "options", "onChange"]),
              _hoisted_40
            ])
          ], 512 /* NEED_PATCH */), [
            [_vShow, _ctx.selectedGroups.length === 0]
          ])
        ]),
        _hoisted_41,
        _createCommentVNode(" Players "),
        _hoisted_42,
        (_ctx.theUser.groups.length > 0)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              id: "`button-new-player",
              class: "my-1 mr-2",
              onVclick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.newPlayer()))
            }, {
              default: _withCtx(() => [
                _hoisted_43
              ]),
              _: 1 /* STABLE */
            }))
          : (_openBlock(), _createElementBlock("p", _hoisted_44, "Add this user to a group before creating Players")),
        _createElementVNode("div", _hoisted_45, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myPlayers, (p) => {
            return (_openBlock(), _createElementBlock("div", {
              key: p._id,
              class: "flex flex-col"
            }, [
              _createVNode(_component_MonitorPlayerItem, {
                class: "m-2",
                player: p,
                edit: _ctx.editingParticipant == p._id
              }, {
                default: _withCtx(() => [
                  (!_ctx.editingParticipant)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        id: `button-edit-player-${p._id}`,
                        childclass: 'w-32',
                        backgroundcolour: 'bg-white',
                        textcolour: 'text-black',
                        class: "my-1 mr-2",
                        onVclick: ($event: any) => (_ctx.editingParticipant = p._id)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_46
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "onVclick"]))
                    : (_ctx.editingParticipant === p._id)
                      ? (_openBlock(), _createBlock(_component_Button, {
                          key: 1,
                          id: "`button-doneediting",
                          backgroundcolour: 'bg-white',
                          textcolour: 'text-black',
                          class: "my-1 mr-2",
                          onVclick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.editingParticipant = ''))
                        }, {
                          default: _withCtx(() => [
                            _hoisted_47
                          ]),
                          _: 1 /* STABLE */
                        }))
                      : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["player", "edit"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ]),
        _hoisted_48,
        _createCommentVNode(" Games "),
        _hoisted_49,
        _createVNode(_component_Button, {
          id: "`button-new-player",
          class: "my-1 mr-2",
          onVclick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.newGame()))
        }, {
          default: _withCtx(() => [
            _hoisted_50
          ]),
          _: 1 /* STABLE */
        }),
        _createElementVNode("div", _hoisted_51, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.myGames, (g) => {
            return (_openBlock(), _createElementBlock("div", {
              key: g._id,
              class: "flex flex-col"
            }, [
              _createVNode(_component_MonitorGameItem, {
                class: "m-2",
                game: g,
                edit: _ctx.editingGame == g._id,
                onGamedeleted: _cache[26] || (_cache[26] = ($event: any) => (_ctx.editingGame = ''))
              }, {
                closeEdit: _withCtx(() => [
                  (_ctx.editingGame)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        id: "`button-doneediting",
                        backgroundcolour: 'bg-white',
                        textcolour: 'text-black',
                        class: "col-start-2 my-2 mr-2",
                        onVclick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.editingGame = ''))
                      }, {
                        default: _withCtx(() => [
                          _hoisted_53
                        ]),
                        _: 1 /* STABLE */
                      }))
                    : _createCommentVNode("v-if", true)
                ]),
                default: _withCtx(() => [
                  (!_ctx.editingGame)
                    ? (_openBlock(), _createBlock(_component_Button, {
                        key: 0,
                        id: `button-edit-player-${g._id}`,
                        childclass: 'w-32',
                        backgroundcolour: 'bg-white',
                        textcolour: 'text-black',
                        class: "my-1 mr-2",
                        onVclick: ($event: any) => (_ctx.editingGame = g._id)
                      }, {
                        default: _withCtx(() => [
                          _hoisted_52
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["id", "onVclick"]))
                    : _createCommentVNode("v-if", true)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["game", "edit"])
            ]))
          }), 128 /* KEYED_FRAGMENT */))
        ])
      ])
    ])
  ]))
}